import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { WeekStart } from 'flowbite-react';
import { DateTime } from 'luxon';

export interface DateState {
    date: string
}

function initialDate(): string {
    const now = DateTime.now()
    let initialDate: DateTime<true>
    if (now.weekday >= WeekStart.Friday && now.hour > 12) {
        initialDate = now.plus({week: 1}).set({weekday: WeekStart.Monday})
    } else {
        initialDate = now
    }
    return initialDate.toISODate()
}

const initialState: DateState = {
    date: initialDate()
}

export const dateSlice = createSlice({
    name: 'date',
    initialState,
    reducers: (create) => ({
        selectDate: create.preparedReducer(
            (date: DateTime) => ({payload: date.toISODate()!}),
            (state, action: PayloadAction<string>) => {
                state.date = action.payload
            }
        )
    })
})

export const { selectDate } = dateSlice.actions
